import React from "react";
import moment from "moment";
import ProjectReportsTableColumn from "./ProjectReportsTableColumn";
import ReportsTableActionColumn from "../../../components/tables/columns/ReportsTableActionColumn";
import useOpenDocument from "../../../hooks/useOpenDocument";
import { DateDisplay, ProfileDisplay } from "../../../components";
import { ThemedSpan } from "../../../components/utilities";
import { openPdfViewerModal } from "../../../components/modals/ViewPdfModal";
import { useReportPdfData } from "../../../hooks/useReportPdfData";

const ProjectReportsTableRow = ({ data, project, dateFormat = "DD/MM/YYYY" }) => {
    const { openDocument, isFetching: isOpening } = useOpenDocument();
    const { target } = project;
    const {
        id,
        masterAccountId,
        documentId,
        typeDescription,
        reportName,
        statusDescription,
        authorId,
        complianceUserId,
        compliantDate,
        sentDate,
        sentByMediaTypeDescription,
        createdDate,
        isStatusTerminated,
        isPdfGenerated
    } = data;
    const { getPdfBytes: getReportPdfBytes } = useReportPdfData(masterAccountId, id);

    const calculateDateDisplayColourVariant = (dateToCompare) => {
        let displayDate = moment(dateToCompare || '');
        let projectDate = moment(target || '');

        if (projectDate.isBefore(displayDate, 'day')) {
            return 'danger';
        }
        else if (projectDate.isSameOrAfter(displayDate, 'day')) {
            return 'success';
        }
        else {
            return 'dark';
        }
    };

    const onOpenReport = (e) => {
        if (e && typeof (e.preventDefault) === 'function') {
            e.preventDefault();
        }
        if (isOpening) {
            return;
        }
        if (isPdfGenerated) {
            return;
        }
        openDocument(documentId, `${reportName}.docx`);
    };

    const onOpenReportPdf = (e) => {
        if (e && typeof (e.preventDefault) === 'function') {
            e.preventDefault();
        }
        if (isPdfGenerated === false) {
            return;
        }
        getReportPdfBytes().then(
            r => openPdfViewerModal({ data: r, title: data ? `View: ${data.reportName}` : 'View Report' })
        );
    };

    return (
        <tr>
            <ProjectReportsTableColumn>
                <p className="m-0 lh-1">
                    <a href={`open?id=${documentId}`} onClick={(e) => isStatusTerminated === true ? onOpenReportPdf(e) : onOpenReport(e)}>{reportName}</a>
                    <br />
                    <ThemedSpan variant="muted" className="fs-smallest">{typeDescription}</ThemedSpan>
                </p>
            </ProjectReportsTableColumn>
            <ProjectReportsTableColumn>
                {statusDescription}
            </ProjectReportsTableColumn>
            <ProjectReportsTableColumn>
                {!authorId
                    ? "Not Assigned"
                    : (<ProfileDisplay userId={authorId} />)
                }
            </ProjectReportsTableColumn>
            <ProjectReportsTableColumn>
                {!complianceUserId
                    ? "Not Assigned"
                    : (<ProfileDisplay userId={complianceUserId} />)
                }
            </ProjectReportsTableColumn>
            <ProjectReportsTableColumn className="col-1">
                {!compliantDate && (<span>-</span>)}
                {compliantDate && <DateDisplay variant={calculateDateDisplayColourVariant(compliantDate)} format={dateFormat}>{compliantDate}</DateDisplay>}
            </ProjectReportsTableColumn>
            <ProjectReportsTableColumn className="col-1">
                {!sentDate && (<span>-</span>)}
                {sentDate && (<DateDisplay variant={calculateDateDisplayColourVariant(sentDate)} format={dateFormat}>{sentDate}</DateDisplay>)}
            </ProjectReportsTableColumn>
            <ProjectReportsTableColumn>
                {sentByMediaTypeDescription ?? "-"}
            </ProjectReportsTableColumn>
            <ProjectReportsTableColumn>
                <DateDisplay format={dateFormat}>{createdDate}</DateDisplay>
            </ProjectReportsTableColumn>
            <ReportsTableActionColumn className="col-md-auto text-center" data={data} />
        </tr>
    );
};

export default ProjectReportsTableRow;